import { Box, Button, Section, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
}

const WorkedTimeCategorization = ({ attendanceSetting }: Props) => {
  const { navigation } = useNavigation()
  const routeParams = {
    id: 'time_tracking',
    settingId: attendanceSetting?.attributes.id.toString() || 'default',
    tabId: 'time_ranges',
  }
  const route = navigation.settings.time_tracking.settingId.tabId.fullPath(routeParams)

  return (
    <Section
      illustration="night"
      title={i18n.t('time_tracking.settings.time_blocks.section.title')}
      description={i18n.t('time_tracking.settings.time_blocks.section.description')}
    >
      <Box
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        alignItems="center"
        flexDirection="row"
        justifyContent="spaceBetween"
        paddingY="s16"
        paddingX="s24"
      >
        <Box gap="s8">
          <Text.Normal weight="medium" color="grey1000">
            {i18n.t('time_tracking.settings.time_blocks.section.content.title')}
          </Text.Normal>
          <Text.Normal>
            {i18n.t('time_tracking.settings.time_blocks.section.content.description')}
          </Text.Normal>
        </Box>
        <Button.Router
          aria-label={i18n.t('time_tracking.settings.time_blocks.section.go_to_aria_label')}
          to={route}
          type="secondary"
          iconName="arrow-right"
        />
      </Box>
    </Section>
  )
}

export default WorkedTimeCategorization
